<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'template-manage',
    subject: 'Checklist',
  },
})

const page = {
  groupTitle: 'Checklist & Inspeksi',
  icon: 'ri-file-list-3-line',
  color: 'primary',
  title: 'Kelola Template Checklist',
  description: 'Membuat dan mengubah daftar pertanyaan/item checklist yang dipakai staf lain untuk mengisi.',
  purpose: 'Panduan bagi admin/penanggung jawab mutu yang menyiapkan template checklist untuk dipakai unit-unit.',
  concept: [
    {
      icon: 'ri-shield-check-line',
      title: 'Template Tidak Pernah Berubah karena Isian Lama',
      text: 'Mengubah satu item di template TIDAK mengubah hasil isian checklist yang sudah pernah disimpan sebelumnya — riwayat isian lama tetap utuh apa adanya, sesuai kondisi saat diisi.',
    },
  ],
  steps: [
    { title: 'Buka menu Checklist & Inspeksi → Template', detail: 'Klik "Buat Template".' },
    { title: 'Isi Kategori dan Nama Template', detail: 'Mis. Kategori "APAR", Nama "Checklist APAR Bulanan".' },
    { title: 'Tambahkan item satu per satu', detail: 'Setiap item butuh: teks pertanyaan, dan jenis jawaban (Ya/Tidak, Skor, atau Teks).' },
    { title: 'Klik "Simpan Template"', detail: 'Template langsung bisa dipakai staf yang punya akses isi checklist.' },
  ],
  warning: 'Setelah template dipakai (sudah ada hasil isian), Anda hanya bisa mengubah nama/kategori/status aktif template — daftar item TIDAK bisa diubah lagi lewat form edit, supaya riwayat isian lama tidak jadi tidak konsisten.',
  tips: [
    'Rencanakan urutan dan jumlah item dengan matang sebelum template mulai dipakai — mengubah item setelah itu tidak bisa lewat halaman ini.',
    'Nonaktifkan (bukan hapus) template lama yang sudah tidak dipakai, supaya riwayat isian lamanya tetap bisa dilihat di laporan.',
  ],
  faq: [
    { q: 'Kenapa saya tidak bisa menambah item baru ke template yang sudah lama dipakai?', a: 'Ini disengaja (BR-005) — supaya riwayat isian checklist lama tetap konsisten dengan bentuk template saat itu diisi. Kalau memang butuh item baru, buat template baru.' },
  ],
  related: [
    { title: 'Isi Checklist Harian', sub: 'Cara mengisi checklist dari template', icon: 'ri-checkbox-multiple-line', color: 'success', to: { name: 'help-checklist-isi-checklist' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
